/*
 * @Author: GeekMzy
 * @Date: 2023-07-18 10:51:22
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\service\api-base-grid.ts
 */
/*
 * @Autor: GeekMzy
 * @Date: 2022-05-25 09:50:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 10:51:42
 * @FilePath: \htwlgs-drainage-webv2.2\src\service\api-base-monitor.ts
 * @Author: desktop-1llkr2o
 */
import { AxiosRequestConfig, CancelToken } from 'axios'
import NProgress from 'nprogress'
import axiosInstance from './http' // 封装后的axios

export type RequestQueryParamsType = Record<string | number, any>

export class ApiBase {
  private baseUrl: string | undefined = process.env.VUE_APP_BASE_URL + 'api/grid'

  private addQueryParam(query: RequestQueryParamsType, key: string) {
    return (
      encodeURIComponent(key) +
      '=' +
      encodeURIComponent(Array.isArray(query[key]) ? query[key].join(',') : query[key])
    )
  }

  protected addQueryParams(rawQuery?: RequestQueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys.length
      ? `?${keys
          .map((key) =>
            typeof query[key] === 'object' && !Array.isArray(query[key])
              ? this.addQueryParams(query[key] as object).substring(1)
              : this.addQueryParam(query, key)
          )
          .join('&')}`
      : ''
  }

  public request = <T = any>(
    path: string,
    method: string,
    body?: any,
    cancelToken?: CancelToken
  ): Promise<T> => {
    const options = <AxiosRequestConfig>{
      method: method,
      data: body,
      url: `${this.baseUrl}${path}`,
      headers: {
        Accept: 'application/json, text/plain, */*',
      },
      cancelToken,
    }
    NProgress.start()
    const promise = axiosInstance.request(options)
    return promise.then(
      async (response: any) => {
        NProgress.done()
        return response.data
      },
      (reject) => {
        console.log(Error(reject))
        NProgress.done()
      }
    )
  }
}
